import { render, staticRenderFns } from "./ExMachina.vue?vue&type=template&id=2b1f1884"
import script from "./ExMachina.vue?vue&type=script&lang=js"
export * from "./ExMachina.vue?vue&type=script&lang=js"
import style0 from "./ExMachina.vue?vue&type=style&index=0&id=2b1f1884&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports